import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-behaviour',
  templateUrl: './behaviour.component.html',
  styleUrls: ['./behaviour.component.css']
})
export class BehaviourComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
